import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createCaseConversation = async (conversation) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createConversation($caseId: String!, $subject: String!, $body: String!, $recipients: [RecipientInput], $attachmentIds: [Int], $templateWrapperId: Int, $ccRecipients: [RecipientInput], $bccRecipients: [RecipientInput] ) {
        createConversation(caseId: $caseId, subject: $subject, body: $body, recipients: $recipients, attachmentIds: $attachmentIds, templateWrapperId: $templateWrapperId, ccRecipients: $ccRecipients, bccRecipients: $bccRecipients ) {
          conversationId
          conversationMessage {
            id
            subject
            body
            createdAt
            updatedAt
            sendStatus
            sendStatusDetail
            sendVerifiedAt
          }
          message
          error
          lowLevelErrorMessage 
        }
      }`),
      variables: { caseId: conversation.caseId, subject: conversation.subject, body: conversation.body, recipients: conversation.recipients, ccRecipients: conversation.ccRecipients, bccRecipients: conversation.bccRecipients, attachmentIds: conversation.attachmentIds, templateWrapperId: conversation.templateWrapperId }
    }
  )
  return response.data
}

export const attachConversationToCase = async (conversationId, caseId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation attachConversationToCase($conversationId: Int!, $caseId: String!) {
          attachConversationToCase(conversationId: $conversationId, caseId: $caseId) {
            lowLevelErrorMessage
            message
            error 
          }
        }`
      ),
      variables: { conversationId, caseId: caseId }
    }
  )
  return response.data
}

export const archiveMessage = async (messageId, markArchived) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation archiveMessage($messageId: Int!, $markArchived: Boolean!) {
          archiveMessage(messageId: $messageId, markArchived: $markArchived) {
            lowLevelErrorMessage
            message
            error 
          }
        }`
      ),
      variables: { messageId: messageId, markArchived: markArchived }
    }
  )
  return response.data.archiveMessage
}

export const markConversationAsRead = async (conversationId, markRead) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation markConversationAsRead($conversationId: Int!, $markRead: Boolean!) {
          markConversationAsRead(conversationId: $conversationId, markRead: $markRead) {
            lowLevelErrorMessage
            message
            error 
          }
        }`
      ),
      variables: { conversationId, markRead: markRead }
    }
  )
  return response.data
}

export const removeConversationFromCase = async (conversationId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation removeConversationFromCase($conversationId: Int!) {
          removeConversationFromCase(conversationId: $conversationId) {
            message
            lowLevelErrorMessage
            error
          }
        }`
      ),
      variables: { conversationId }
    }
  )
  return response.data
}

export const replyCaseConversation = async (conversation) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation replyToConversation($conversationId: Int!, $body: String!, $recipients: [RecipientInput], $attachmentIds: [Int], $templateWrapperId: Int, $ccRecipients: [RecipientInput], $bccRecipients: [RecipientInput] ) {
        replyToConversation(conversationId: $conversationId, body: $body, recipients: $recipients, attachmentIds: $attachmentIds, templateWrapperId: $templateWrapperId, ccRecipients: $ccRecipients, bccRecipients: $bccRecipients) {
          conversationId
          conversationMessage { 
            id
            body
            subject
            createdAt
            updatedAt
            sendStatus
            sendStatusDetail
            sendVerifiedAt
            recipients { id displayName type email userId teamId }
            ccRecipients { id displayName type email userId teamId }
            bccRecipients { id displayName type email userId teamId }
            attachments {
              id
              url
              createdAt
              updatedAt
              size
              filename
              extension
              contentType
              isInline
            }
            from { id displayName type email userId teamId }
          }
          message
          error
          lowLevelErrorMessage
        }
      }`),
      variables: conversation
    }
  )
  return response.data.replyToConversation
}

export const forwardMessage = async (messageId, email) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation forwardMessage($messageId: Int!, $email: String!){
        forwardMessage(messageId: $messageId, email: $email) {
          lowLevelErrorMessage
          message
          error 
        }
      }
      `),
      variables: { messageId, email }
    }
  )
  return response.data.forwardMessage
}

export const deleteMessage = async (messageId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteMessage($messageId: Int!) {
          deleteMessage(messageId: $messageId) {
            lowLevelErrorMessage
            message
            error
          }
        }
      `),
      variables: { messageId }
    }
  )
  return response.data.deleteMessage
}

export const resendConversationMessages = async (messageIds) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation resendMessages($messageIds: [Int!]!) {
          resendMessages(messageIds: $messageIds) {
            message
            lowLevelErrorMessage
            error
          }
        }
      `),
      variables: { messageIds },
    }
  )
  return response.data.resendMessages
}

export const accountRecipients = async (prefix, page, pageSize) => {
  try {
    const response = await apollo.query(
      {
        query: gql(`
          query($prefix: String, $page: Int, $pageSize: Int) {
            currentUser {
              account {
                recipients(prefix: $prefix, page: $page, pageSize: $pageSize) {
                  id
                  displayName
                  email
                  type
                  userId
                  teamId
                }
              }
            }
          }
        `),
        variables: { prefix, page, pageSize }
      })
    return response.data.currentUser.account.recipients
  } catch (error) {
    console.error(error)
  }
}

const commsMessageStatusObservers = {}

export const subscribeToCommsMessageStatus = (messageId, onUpdate) => {
  const messageIdKey = String(messageId)
  
  // Unsubscribe from existing subscription if any
  if (commsMessageStatusObservers[messageIdKey]) {
    commsMessageStatusObservers[messageIdKey].unsubscribe()
  }
  
  console.log("subscribeToCommsMessageStatus", "Subscribing to message status for message id", messageId)
  const subscription = apollo.subscribe({
    query: gql(`
      subscription commsMessageStatusUpdated($messageId: Int!) {
        commsMessageStatusUpdated(messageId: $messageId) {
          message {
            id
            sendStatus
            sendStatusDetail
            sendVerifiedAt
            updatedAt
          }
          error
          responseMessage
          lowLevelErrorMessage
        }
      }
    `),
    variables: { messageId: parseInt(messageId, 10) }
  }).subscribe({
    next(response) {
      if (response.data && response.data.commsMessageStatusUpdated) {
        const updatedMessage = response.data.commsMessageStatusUpdated.message
        console.log("subscribeToCommsMessageStatus", "Received status update", updatedMessage)
        if (onUpdate) {
          onUpdate(updatedMessage)
        }
      }
    },
    error(err) {
      console.error("subscribeToCommsMessageStatus", "error", err)
      // Retry subscription on error
      window.setTimeout(() => {
        console.log("subscribeToCommsMessageStatus", "retrying subscribe")
        subscribeToCommsMessageStatus(messageId, onUpdate)
      }, 500)
    },
    complete() {
      console.log("subscribeToCommsMessageStatus", "complete")
      // Retry subscription when complete (connection lost)
      window.setTimeout(() => {
        console.log("subscribeToCommsMessageStatus", "retrying subscribe")
        subscribeToCommsMessageStatus(messageId, onUpdate)
      }, 500)
    },
  })
  
  commsMessageStatusObservers[messageIdKey] = subscription
  return subscription
}

export const unsubscribeFromCommsMessageStatus = (messageId) => {
  const messageIdKey = String(messageId)
  if (commsMessageStatusObservers[messageIdKey]) {
    commsMessageStatusObservers[messageIdKey].unsubscribe()
    delete commsMessageStatusObservers[messageIdKey]
    console.log("unsubscribeFromCommsMessageStatus", "Unsubscribed from message", messageId)
  } else {
    console.log("unsubscribeFromCommsMessageStatus", "No active subscription to unsubscribe from for message", messageId)
  }
}